/**
 * Bundled catalog imagery for store items when `image_url` is unset.
 * CRA resolves imports to stable asset URLs at build time.
 */

import friendshipBraceletImg from '../resources/friendshipbracelet.png';
import postcardImg from '../resources/postcard.png';

const BY_ITEM_TYPE = {
  physical: friendshipBraceletImg,
  postcard: postcardImg,
};

/**
 * @param {{ image_url?: string | null, item_type?: string }} item
 * @returns {string | null} Image URL for <img src>, or null for letter fallback
 */
export function getStoreItemDisplayImage(item) {
  if (!item) return null;
  if (item.image_url && String(item.image_url).trim()) return item.image_url;
  const url = BY_ITEM_TYPE[item.item_type];
  return url || null;
}

/** Disclaimer copy for the store catalog (used on `/store` grid view). */
export const STORE_PRODUCT_IMAGE_DISCLAIMER =
  'Product photos are illustrative; the item you receive may differ slightly from what is shown.';
